export default __webpack_public_path__ + "static/media/setapracima.abe332cf.svg";